import styled from 'styled-components';
import { IThemeProvider } from '../../../styles/theme';


export const ProgressBarTileCont = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
`;

export const ProgressLabelCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({theme}:IThemeProvider) =>`
    margin: ${theme.layout.spacing.centy} 0 0 0;
  `}
`;

export const ExpandIconCont = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
    right: 2px;
    
  ${({theme}:IThemeProvider) =>`
    margin: 0 0 ${theme.layout.spacing.mikro} 0;
  `}
`;